import { ReactNode } from 'react';

import classNames from 'classnames';

import {
  JumpLinkDestination,
  JumpLinkDestinationProps,
} from '@/components/JumpLinks';

interface PageSectionBaseProps {
  children: ReactNode;
  padTop?: boolean;
  padBottom?: boolean;
  grayBackground?: boolean;
  additionalClasses?: string;
  id?: string;
  showGridLines?: boolean;
  jumpLinkDestination?: Omit<JumpLinkDestinationProps, 'id'>;
}

interface PageSectionWithIDProps extends PageSectionBaseProps {
  id: string;
  jumpLinkDestination: Omit<JumpLinkDestinationProps, 'id'>;
}

interface PageSectionWithoutIdProps extends PageSectionBaseProps {
  id?: string;
  jumpLinkDestination?: never;
}

type PageSectionProps = PageSectionWithIDProps | PageSectionWithoutIdProps;

export function PageSection({
  padTop = true,
  padBottom = true,
  grayBackground = false,
  children,
  additionalClasses,
  id,
  showGridLines = false,
  jumpLinkDestination,
}: PageSectionProps) {
  return (
    <section
      id={id}
      className={classNames(
        {
          'bg-offwhite dark:bg-gray-700': grayBackground,
          "bg-offwhite bg-[url('/images/grid-20px-center.svg')] bg-[center_top_0]":
            showGridLines,
          'pt-7 md:pt-10': padTop,
          'pb-7 md:pb-10': padBottom,
        },
        additionalClasses,
      )}
    >
      {jumpLinkDestination && (
        <JumpLinkDestination {...jumpLinkDestination} id={id} />
      )}
      {children}
    </section>
  );
}
